<template>
    <v-container fluid>
        <v-breadcrumbs :items="breadcrumbsItems" class="pa-0 mb-2" large></v-breadcrumbs>
        <v-card outlined>
            <v-row>
                <v-col>
                    <v-img :src="studentInfo.avatar_url" class="role-thumbnail  mx-auto my-2">
                    </v-img>
                </v-col>
                <v-col class="my-2">
                    <v-card-text>
                        <v-spacer></v-spacer>
                        <v-row>
                            {{ $t('quiz.title') + '：' }} {{ quizTitle }}
                        </v-row>
                        <v-row>
                            {{ $t('quiz.create_date') + '：' }} {{ quizDate }}
                        </v-row>
                        <v-row>
                            {{ $t('student_detail.name') + '：' }} {{ studentInfo.nickname }}
                        </v-row>
                        <v-row>
                            {{ $t('student_detail.mail') + '：' }} {{ studentInfo.email }}
                        </v-row>
                    </v-card-text>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-card>
        <v-card class="mt-3">
            <v-data-table :headers="headers" :items="datas" hide-default-footer
                :loading-text="$t('general.table.loading')" :no-data-text="$t('general.table.no_data')" :no-results-text="$t('general.table.no_data')"
                disable-sort>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import { assessmentServices } from '@/services/assessment.js';
import { studentServices } from '@/services/student.js';
import { mapState } from "vuex";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export default {
    name: "StudentDetail",
    data() {
        return {
            homeworkId: '',
            quizUuid: '',
            quizTitle: '',
            quizDate: '',
            studentInfo: {},
            headers: [
                {
                    text: '題目',
                    value: 'quest',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                },
                {
                    text: '答案',
                    value: 'ans',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                    filterable: false,
                },
            ],
            datas: [
                {
                    quest: '',
                    ans: '',
                },
            ],
            breadcrumbsItems: [],
        };
    },
    async created() {
        
        this.homeworkId = this.$route.params.id;
        this.quizUuid = this.$route.params.uuid;
        const quizRes = await assessmentServices.getAssessmentResult(this.homeworkId, this.quizUuid)
        const studentRes = await studentServices.getStudentInfo(quizRes.user_id);
        this.studentInfo = studentRes;
        
        this.quizTitle = quizRes.title;

        dayjs.extend(utc)
        dayjs.extend(timezone)
        const tz = dayjs.tz.guess()
        this.quizDate = dayjs.utc(quizRes.create_date).tz(tz).format('YYYY-MM-DD HH:mm:ss');

        const quizAns = JSON.parse(quizRes.ans);
        this.datas = quizRes.quest.map((quest, index) => {
            return {
                quest: quest.title,
                ans: quest.options.find(option => option.grade == quizAns[index])?.text || '',
            }
        });
        
        this.breadcrumbsItems.push({
            text: this.$t('index.title'),
            disabled: false,
            href: `/diary`,
        }, {
            text: this.homeworkName,
            disabled: false,
            href: `/diary/homework/${this.homeworkId}`,
        }, {
            text: this.$t('menu.diary_quiz'),
            disabled: false,
            href: `/diary/homework/${this.homeworkId}/quiz`,
        }, {
            text: this.studentInfo.nickname,
            disabled: true,
            //href: `/diary/homework/${this.homeworkId}/student/${this.studentId}`,
        }
        );
    },
    computed: {
        ...mapState(["homeworkName"]),
    },
    methods: {
        
    },
    watch: {
        homeworkName() {
            this.breadcrumbsItems[1].text = this.homeworkName;
        },
    },
};
</script>

<style scoped>
.role-thumbnail {
    width: 100px;
    align-items: center;
}

</style>